/*
 * Routes-other.ts
 * Description: Includes the declaration of the
 * other routes for Vue Router
 */

// Importing components
import PageDashboard from '@/pages/PageDashboard.vue';
import PageLog from '@/pages/log/PageLog.vue';

import PageCartCheckout from '@/pages/PageCartCheckout.vue';

import PageDonatedFunds from '@/pages/donations/PageDonatedFunds.vue';
import PageDonations from '@/pages/donations/PageDonations.vue';

import PageStartDelivery from '@/pages/orders/PageStartDelivery.vue';
import PageTrackDelivery from '@/pages/orders/PageTrackDelivery.vue';

const routesOther = [
    // Defining the delivery page route
    {
        path: '/restaurants/:id/orders/:order_id/delivery',
        name: 'start-delivery',
        component: PageStartDelivery,
        props: { id: Number, order_id: Number },
        meta: { requiresAuth: true, ManageDeliveries: true },
    },
    // Defining the delivery page route
    {
        path: '/orders/:order_id/track',
        name: 'track-delivery',
        component: PageTrackDelivery,
        props: { order_id: Number },
        meta: { requiresAuth: true, ManageDeliveries: true },
    },
    // Defining the login page route
    {
        path: '/dashboard',
        name: 'dashboard',
        component: PageDashboard,
        meta: { requiresAuth: true, ManageSystem: true },
    },
    // Defining the users page route
    {
        path: '/donations',
        name: 'donations',
        component: PageDonations,
        meta: { requiresAuth: true, ManageDonations: true },
    },
    // Defining the users page route
    {
        path: '/donated-funds',
        name: 'donated-funds',
        component: PageDonatedFunds,
        meta: { requiresAuth: true, ManageDonations: true },
    },
    // Defining the cart checkout page route
    {
        path: '/cart',
        name: 'cart-checkout',
        component: PageCartCheckout,
    },
    // Defining the log page route
    {
        path: '/log',
        name: 'log',
        component: PageLog,
        meta: { requiresAuth: true, ManageSystem: true },
    },
];
export default routesOther;
